import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AuthProvider } from './../../providers/auth/auth';

@IonicPage()
@Component({
  selector: 'page-user',
  templateUrl: 'user.html',
})
export class UserPage {
  userData: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public authPrvdr: AuthProvider) {}

  ionViewDidLoad() {
    this.getUserData();
  }

  getUserData(): void {
    // this.authPrvdr.checkLogin();
    this.authPrvdr.authUser.subscribe((jwt) => {
      if (jwt) {
        this.authPrvdr.userData.subscribe((res) => {
          this.userData = res;
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/user/user.ts